import { render, staticRenderFns } from "./QueueStatus.vue?vue&type=template&id=b2ae20b0"
import script from "./QueueStatus.vue?vue&type=script&lang=js"
export * from "./QueueStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/websites/streamlined-business-solutions/sbs-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b2ae20b0')) {
      api.createRecord('b2ae20b0', component.options)
    } else {
      api.reload('b2ae20b0', component.options)
    }
    module.hot.accept("./QueueStatus.vue?vue&type=template&id=b2ae20b0", function () {
      api.rerender('b2ae20b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/bookkeeping/widgets/QueueStatus.vue"
export default component.exports